<mat-card >
  <mat-card-header class="titreFrm">
      <mat-card-title>{{'paramétre TAUX'.toUpperCase()}}</mat-card-title>
  </mat-card-header>
  <mat-card-content class="border">
    <app-avt-listes 
      #listeTauxComponen 
      [showFilter]="true" 
      [heightTable]="'400'" 
      [dataSourceBrut]="[]" 
      [listBtn]="listBtn"
      (btnTable)="clickBtnHeat($event)"
      [displayedColumnsBrut]="Columns" >
    </app-avt-listes>
  </mat-card-content>
</mat-card>
  